import { StoreType } from '@/redux/store';

export const getFeatureFlags = ({ featureFlags }: StoreType) => featureFlags;
